{
  "pending": "In attesa",
  "delivered": "Consegnato",
  "retry": "Riprova",
  "error": "In errore",
  "cancelling": "Annullamento",
  "cancelled": "Annullato",
  "paused": "In pausa",
  "done": "Terminato",
  "running": "In corso",
  "expired": "Scaduta",
  "dateFormat": "DD/MM/YYYY alle HH:mm",
  "operationType": {
    "CRTCLT_RENEWAL_DVC": "Rinnovo del certificato",
    "CRTCLT_RENEWAL_APP": "Rinnovo del certificato",
    "FIRMWARE_UPGRADE_DVC": "Aggiornamento del firmware"
  },
  "type": "Tipo di operazione",
  "createdAt": "Data di creazione",
  "launchedAt": "Data di avvio prevista",
  "updatedAt": "Data di modifica",
  "state": "Stato dell’operazione",
  "certificate": {
    "update": {
      "label": "Rinnovo certificato",
      "dateTimeError": "Il campo della data è richiesto per l’aggiornamento del certificato",
      "plannedStartAt": {
        "label": "Parametrizza l'operazione",
        "placeholder": "Seleziona una data di aggiornamento"
      },
      "dateNotValidAfterRenewal": "La data deve essere valida prima della scadenza del certificato"
    }
  },
  "firmware": {
    "update": {
      "label": "Aggiornamento del firmware",
      "description": "Parametrizzare la data e l’ora della procedura di avvio dell’aggiornamento del firmware dell’{name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Il firmware è obbligatorio",
      "plannedStartAt": "Data di aggiornamento del firmware (GG/MM/AAAA HH:MM)",
      "notaBene": "L’aggiornamento del firmware sarà effettuato durante la prossima comunicazione con l’{name} a partire dalla data di aggiornamento del firmware stesso.",
      "dateTimeError": "Il campo della data è richiesto per l’aggiornamento del firmware",
      "warningMessage": "Attenzione: l’aggiornamento del firmware comporterà il riavvio dell’apparato alla fine dell’aggiornamento.",
      "version": "Versione",
      "dtwin": {
        "description": "Parametrizzare la configurazione dell’operazione di aggiornamento del firmware.",
        "launchPlannedAt": "Data dell’aggiornamento",
        "validation": {
          "launchPlannedAt": "La data dell’aggiornamento è obbligatoria."
        },
        "startsAtCreation": "Trasmissione dell’operazione all’apparato il prima possibile",
        "firmware": "Selezionare un firmware nell’elenco qui sopra"
      },
      "scheduled": {
        "warningMessage": "L’apparato presenta già un’operazione dello stesso tipo pianificata, in attesa o in corso"
      }
    }
  },
  "dateInferiorToToday": "La data non deve essere inferiore alla data/ora attuale",
  "empty": "Non è stata trovata alcuna operazione",
  "actions": "Azioni",
  "queued": "In coda",
  "failed": "Non riuscito",
  "unknown": "Stato sconosciuto",
  "scheduled": "Programmata",
  "configuration": {
    "selfSupportingVersion": "Versione indipendente",
    "globalVersion": "Versione globale",
    "specificVersion": "Versione specifica",
    "updatedDate": "Data aggiornata"
  },
  "unitary": {
    "title": "Unitario"
  },
  "campaign": {
    "title": "Campagna"
  },
  "trigger": {
    "title": "Attivatore",
    "AUTO": "Automatico",
    "MANUAL": "Manuale"
  },
  "on_hold": "In sospeso"
}
